import React from 'react';

import Select from 'react-select';

import reviewer from '@/data/reviewer';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectReviewer: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={reviewer.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={reviewer}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectReviewer;
